export default {
   layout: {
        zh: '中文简体',
        en: 'English',
        kr: '한국어',
        tc:'中文繁体',
        th:'泰语ภาษาไทย',
        vn:'Việt Nam'
    },
    footer:{
      desc:''
    },
    menu: {
      home: 'ホーム',
      node: 'ノード',
      exchange: '交換',
      staking: 'ステーキング',
      me: 'マイページ',
    },
    home: {
      ecological: 'エコロジーノード',
      more: 'もっと見る',
      genesis: 'ジェネシスノード',
      onlyLeft: '残り僅か',
      coin: 'コイン比率',
      subscription: '即時購入',
      application: 'エコロジーアプリケーション',
      desc1: 'モールポイント交換・商品支払い',
      desc2: 'ノード購入・ステーキング報酬・ガバナンス投票',
      desc3: '金資産交換（RWAマッピング）',
      desc4: 'マーチャント割引・配当インセンティブ',
      desc5: 'プラットフォーム手数料決済・利益分配',
      community: 'DAOコミュニティガバナンス・投票決定',
      partners: 'パートナー',
      contact: 'お問い合わせ',
    },
    node:{
      ecology: 'エコロジーノード',
      meNode: 'マイノード',
      genesis: 'ジェネシスノード',
      onlyLeft: '残り僅か',
      coin: 'コイン比率',
      subscription: '即時購入',
      diamond: 'ダイヤモンノード',
      revenue: '報酬を確認',
      gold: 'ゴールドノード',
      silver: 'シルバーノード',
      noNode: 'ノードがない、即時購入',
      totalCollection: '合計受領',
      toBeClaimed: '受領待ち',
      claimed: '受領',
      totalRelease: '合計リリース',
      released: 'リリース済み',
      toBeReleased: 'リリース待ち',
      genesisReleased: 'ジェネシスノードリリース',
      more: '下に引っ張って更多をロード',
      nodeSubscription: 'ノード購入',
      receivedTo: '受領先',
      networkFee: 'ネットワーク手数料',
      confirmSubscription: '購入を確定',
      progress: '取引実行中',
      executionSuccessful: '実行成功',
      at: 'で確認',
      view: '',
      releaseRecord: 'リリース記録',
      claimRecord: '受領記録',
      nonce: 'ノンス',
      claimIncome: '報酬を受領',
      quantityClaimed: '受領数量',
      pickup: '受領可能',
      all: 'すべて',
      confirmToReceive: '受領を確定',
      node0: 'ダイヤモンドノード',
      node1: 'プラチナノード',
      node2: 'ゴールドノード',
      node3: 'エメラルドノード',
      node4: 'シルバーノード',
      node5: 'ブロンズノード',

      release1:'KOL インセンティブ',
       release2:'グローバルエアドロップ',
       release3:'流動性プール',
       release4:'創設チーム',
       release5:'エコシステムファンド',
       release6:'機関',
       release7:'グローバルノード',
       release8:'エコシステムマイニングプール',
       release9:'ステーキングマイニングプール',

       
       success:'成功',
       error:'失敗',
       nocount:'このノードは完売しました'
    },
    exchange:{
      at: 'で確認',
      view: '',
      more:'更多',
      indicator:'指標',
      market:'市場価格交換',
      payment:'支払い',
      all:'すべて',
      received:'受領',
      slippage:'スリッページ',
      minimum:'最小受領額',
      cost:'ネットワーク手数料',
      confirmExchange:'交換を確定',
      record:'履歴',
      completed:'かんりょう',
      error:'失敗',
      downMore:'下に引っ張って更多をロード',
      price:'価格',
      progress:'取引実行中',
      wallet:'ウォレット発起',
      refuse:'拒否',
      nodeSubscription: 'ノード購入',
      executionSuccessful: '実行成功',
      nonce: 'ノンス',
      confirm:'確定',
    },
    me:{
      assets: '総資産',
      recharge: 'チャージ',
      transfer: '送金',
      record: '履歴',
    },
    recharge:{
      recharge: 'チャージ',
      title: 'このアドレスはBSC/BEP関連資産のみ対応',
      address: '受領アドレス',
      copy: 'コピー',
      share: '共有',
    },
    record:{
      record: '記録',
      all: 'すべて',
      recharge: 'チャージ',
      transfer: '送金',
      claimed: '受領',
    },
    transfer:{
      transfer: '送金',
      address: '送金先アドレス',
      transferCoin: '送金トークン',
      pla: '送金先アドレスを入力',
      network: '送金ネットワーク',
      mainNetwork:'メインネットを選択',
      transferAmount: '送金金額',
      withdraw: '最小引き出し20',
      all: 'すべて',
      balance: '利用可能残高',
      tips: '送金先アドレスとネットワークを確認ください。チェーン上に上がると資産は回収不可',
      amountReceived: '到着金額',
      free: 'ネットワーク手数料',
    }
  };